import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl, Validators, NgForm } from "@angular/forms";
import { MatDialogRef, MatDialog } from "@angular/material";
import { ErrorDialogComponent } from "../../error-dialog/error-dialog.component";
import { LoginService } from "../login.service";
import { Constants } from "../../../../core/services/constants";
import { AuthenticationService } from "../../../../core/services/authentication.service";
import { SessionStateService } from "../../../../core/services/session-state.service";
import { Observable } from "rxjs/Observable";
import { Router, Params, ActivatedRoute } from "@angular/router";
import { PrivacyPolicyDialogComponent } from "../../privacy-policy-dialog/privacy-policy-dialog.component";

@Component({
  selector: "app-first-login",
  templateUrl: "./first-login.component.html",
  styleUrls: ["./first-login.component.scss"],
})
export class FirstLoginComponent implements OnInit {
  paramEmail;

  seeNewPassword: Boolean;
  seeConfPassword: Boolean;
  statusMessage: string;
  processComplete = false;
  firstLoginForm: FormGroup;
  newPasswordInputError = false;
  newPasswordError = false;
  temporaryPasswordInputError = false;
  loading = false;

  fileNameDialogRef: MatDialogRef<ErrorDialogComponent>;
  privacyPolicyDialogRef: MatDialogRef<PrivacyPolicyDialogComponent>;
  verificationCodeInputError = false;

  constructor(
    private loginService: LoginService,
    private dialog: MatDialog,
    private sessionStateService: SessionStateService,
    private authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.paramEmail = this.route.snapshot.params.paramEmail;
  }

  openDialog(errorMessage: string): void {
    this.fileNameDialogRef = this.dialog.open(ErrorDialogComponent, {
      data: {
        errorMsg: errorMessage,
      },
      autoFocus: false,
      panelClass: "errorPopup",
    });
  }

  ngOnInit() {
    this.paramEmail = this.sessionStateService.getFirstLogin();

    this.firstLoginForm = new FormGroup({
      temporaryPassword: new FormControl(
        "",
        Validators.nullValidator && Validators.required
      ),
      newPassword: new FormControl(
        "",
        Validators.nullValidator && Validators.required
      ),
      confirmPassword: new FormControl(
        "",
        Validators.nullValidator && Validators.required
      ),
    });
  }

  cleanForm() {
    if (this.newPasswordError) {
      this.temporaryPasswordInputError = false;
      this.newPasswordError = false;
      this.newPasswordInputError = false;
      this.statusMessage = "";
    }
  }

  onChangePassword(form: NgForm) {
    if (form.value.newPassword !== form.value.confirmPassword) {
      this.statusMessage = Constants.MSG.PWDS_DONT_MATCH;
      this.newPasswordInputError = true;
      this.newPasswordError = true;
    } else if (!Constants.REGEX.PASSWORD_REGEX.test(form.value.newPassword)) {
      this.statusMessage = Constants.MSG.PWD_RESTRICTIONS;
      this.newPasswordInputError = true;
      this.newPasswordError = true;
    } else {
      this.loading = true;
      const username = this.paramEmail;
      this.loginService
        .confirmAccount(
          username,
          form.value.temporaryPassword,
          form.value.newPassword
        )
        .finally(() => {})
        .subscribe(
          (res) => {
            // console.log(res);
            this.loginService
              .signIn(username, form.value.newPassword)
              .finally(() => {
                this.sessionStateService.deleteFirstLogin();
                this.loading = false;
              })
              .subscribe(
                (login) => this.openPrivacyPolicyDialog(),
                (err) => {
                  //console.log(err);
                }
              );
          },
          (err) => {
            //console.log(err);
            this.loading = false;
            this.verificationCodeInputError = true;
            this.newPasswordError = true;
            this.statusMessage = Constants.MSG.INVALID_VERIFICATION_CODE;
          }
        );
    }
  }

  openPrivacyPolicyDialog(): void {
    this.privacyPolicyDialogRef = this.dialog.open(
      PrivacyPolicyDialogComponent,
      {
        autoFocus: false,
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/login/first-login/first-login.component.ts